(() => {
  const state = { promise: null };

  function loadStylesheet(url) {
    if (!url || document.querySelector(`link[data-lsp-finder-css="${url}"]`)) {
      return Promise.resolve();
    }
    return new Promise((resolve) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = url;
      link.dataset.lspFinderCss = url;
      link.onload = resolve;
      link.onerror = resolve;
      document.head.appendChild(link);
    });
  }

  function loadScript(url) {
    if (!url) return Promise.resolve();
    const existing = [...document.scripts].find((script) => script.src === url);
    if (existing) {
      if (existing.dataset.lspLoaded === 'true') return Promise.resolve();
      return new Promise((resolve) => {
        existing.addEventListener('load', resolve, { once: true });
        existing.addEventListener('error', resolve, { once: true });
      });
    }
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = url;
      script.async = false;
      script.onload = () => {
        script.dataset.lspLoaded = 'true';
        resolve();
      };
      script.onerror = resolve;
      document.head.appendChild(script);
    });
  }

  function loadFinder(root) {
    if (window.LSPFragranceFinder) {
      window.LSPFragranceFinder.initAll(document);
      return Promise.resolve();
    }
    if (state.promise) return state.promise;
    state.promise = Promise.all([
      loadStylesheet(root.dataset.finderCssUrl),
      loadScript(root.dataset.finderIndexUrl),
    ])
      .then(() => loadScript(root.dataset.finderAppUrl))
      .then(() => window.LSPFragranceFinder?.initAll(document));
    return state.promise;
  }

  document.querySelectorAll('details-modal.header__search').forEach((modal) => {
    const root = modal.querySelector('[data-lsp-header-finder]');
    const details = modal.querySelector('details');
    const toggle = modal.querySelector('summary');
    const headerSection = modal.closest('.section-header');
    if (!root || !details || !toggle) return;

    const syncHeaderLayer = () => {
      if (!headerSection) return;
      headerSection.classList.toggle(
        'lsp-search-is-open',
        Boolean(headerSection.querySelector('details-modal.header__search details[open]')),
      );
    };

    details.addEventListener('toggle', syncHeaderLayer);
    syncHeaderLayer();

    toggle.addEventListener('click', () => {
      loadFinder(root).then(() => {
        window.setTimeout(() => root.querySelector('[data-finder-input]')?.focus(), 30);
      });
    });
  });
})();
